var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 6.56569L4.8 10.1657V11.2H5.83431L9.43431 7.6L8.4 6.56569ZM8.96569 6L10 7.03431L11.0343 6L10 4.96569L8.96569 6ZM8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM8 15.2C11.9764 15.2 15.2 11.9764 15.2 8C15.2 4.02355 11.9764 0.8 8 0.8C4.02355 0.8 0.8 4.02355 0.8 8C0.8 11.9764 4.02355 15.2 8 15.2ZM10.2828 4.11716L11.8828 5.71716C12.0391 5.87337 12.0391 6.12663 11.8828 6.28284L6.28284 11.8828C6.20783 11.9579 6.10609 12 6 12H4.4C4.17909 12 4 11.8209 4 11.6V10C4 9.89391 4.04214 9.79217 4.11716 9.71716L9.71716 4.11716C9.87337 3.96095 10.1266 3.96095 10.2828 4.11716Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico_edit.ef86e318fd2793bb56aa056135811a6c.svg";
export { ForwardRef as ReactComponent };